import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { DashboardPage } from "@/features/dashboard/components/dashboard-page";
import { dashboardSearch } from "@/features/dashboard/search";

export const Route = createFileRoute("/_app/dashboard")({
  validateSearch: dashboardSearch,
  beforeLoad: () => {
    if (!useAuth.getState().can("dashboard.view")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <DashboardPage
      search={s}
      onSearch={(next) =>
        void navigate({
          search: (prev) => ({ ...prev, ...next }),
          replace: true,
        })
      }
    />
  );
}
